export function preloadImages(
  urls: string[],
  onProgress?: (percent: number) => void,
): Promise<void> {
  const unique = [...new Set(urls)];

  if (unique.length === 0) {
    onProgress?.(100);
    return Promise.resolve();
  }

  let loaded = 0;
  const report = () => {
    loaded += 1;
    onProgress?.(Math.round((loaded / unique.length) * 100));
  };

  return Promise.all(
    unique.map(
      (url) =>
        new Promise<void>((resolve) => {
          const img = new Image();
          const done = () => {
            report();
            resolve();
          };
          img.onload = done;
          img.onerror = done;
          img.src = url;
        }),
    ),
  ).then(() => undefined);
}
